import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import BookCard from "@/components/BookCard";
import { Heart } from "lucide-react";

export default function Favorites() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/favorites").then((r) => setBooks(r.data)).catch(() => {}).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="favorites-page" className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="label-eyebrow text-sage mb-3 flex items-center gap-2">
        <Heart className="w-3.5 h-3.5" strokeWidth={1.5} /> Your shelf-within-a-shelf
      </div>
      <h1 className="font-serif text-5xl sm:text-6xl tracking-tight">Favorites.</h1>
      <p className="text-muted_ink mt-4 max-w-xl">
        Books you've bookmarked to come back to. Save any book from its page with the heart icon.
      </p>

      <div className="mt-14">
        {loading ? (
          <div className="text-muted_ink">Loading…</div>
        ) : books.length === 0 ? (
          <div className="border border-edge p-16 text-center">
            <Heart className="w-10 h-10 mx-auto text-muted_ink" strokeWidth={1} />
            <div className="font-serif text-3xl italic mt-4 mb-3">No favorites yet.</div>
            <p className="text-muted_ink mb-6">Tap the heart on any book to save it here.</p>
            <Link to="/browse" className="btn-primary">Browse the shelf</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-10">
            {books.map((b, i) => <BookCard key={b.id} book={b} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
